module.exports = __webpack_public_path__ + "img/uk-liver-cancer-male.6d673dfb.png";